import { Form } from "@redriver/cinnamon";
import React from "react";
import { getCustomerAddresses } from "./actions";

const CustomerAddressesDropdown = (props) => (
  <Form.Dropdown lookupAction={getCustomerAddresses} {...props} />
);

export default CustomerAddressesDropdown;
